const variableTypes = {
  SET_VARIABLES_FETCHING: "SET_VARIABLES_FETCHING",
  SET_VARIABLES: "SET_VARIABLES",
  RESET_VARIABLES: "RESET_VARIABLES",
};

export default variableTypes;
